/* eslint-disable no-nested-ternary */
import PropTypes from 'prop-types';
import { matchPath } from 'react-router-dom';
import { Divider, List, ListSubheader, makeStyles } from '@material-ui/core';
import NavItem from './NavItem';

const useStyles = makeStyles((theme) => ({
  divider: {
    borderColor: theme.palette.primary.light
  }
}));

const renderNavItems = ({ depth = 0, items, pathname, search, collapsed }) => (
  <List disablePadding>
    {items.reduce(
      // eslint-disable-next-line no-use-before-define
      (acc, item) => reduceChildRoutes({
        acc,
        item,
        pathname,
        search,
        depth,
        collapsed
      }), []
    )}
  </List>
);

const reduceChildRoutes = ({ acc, pathname, item, depth, collapsed, search }) => {
  const key = `${item.title}-${depth}`;
  const exactMatch = item.path ? (
    item.path.includes('?') && search
      ? item.path === `${pathname}${search}`
      : (
        search ? false : !!matchPath({
          path: item.path,
          end: true,
        }, pathname)
      )
  )
    : false;

  if (item.children) {
    const partialMatch = item.path ? !!matchPath({
      path: item.path,
      end: false,
    }, pathname) : false;

    acc.push(
      <NavItem
        active={partialMatch}
        depth={depth}
        icon={item.icon}
        info={item.info}
        key={key}
        open={partialMatch}
        path={item.path}
        title={item.title}
        badgeCount={item.badgeCount}
      >
        {renderNavItems({
          depth: depth + 1,
          items: item.children,
          pathname
        })}
      </NavItem>
    );
  } else {
    acc.push(
      <NavItem
        active={exactMatch}
        depth={depth}
        icon={item.icon}
        info={item.info}
        key={key}
        path={item.path}
        title={collapsed ? '' : item.title}
        badgeCount={item.badgeCount}
        collapsed={collapsed}
      />
    );
  }

  return acc;
};

const NavSection = (props) => {
  const { items, pathname, search, title, divider, collapsed, ...other } = props;
  const classes = useStyles();

  return (
    <List
      subheader={(
        divider ? <Divider className={classes.divider} />
          : (
            <ListSubheader
              disableGutters
              disableSticky
              sx={{
                color: 'text.primary',
                fontSize: '0.75rem',
                lineHeight: 2.5,
                fontWeight: 700,
                textTransform: 'uppercase'
              }}
            >
              {title}
            </ListSubheader>
          )
      )}
      {...other}
    >
      {renderNavItems({
        items,
        pathname,
        search,
        collapsed
      })}
    </List>
  );
};

NavSection.propTypes = {
  items: PropTypes.array,
  pathname: PropTypes.string,
  title: PropTypes.string,
  divider: PropTypes.bool,
  collapsed: PropTypes.bool,
  search: PropTypes.string,
};

export default NavSection;
